import React from "react";
import { type AssetType } from "@swo/shared";
import { css } from "@emotion/react";
import { FONTS, fontSize } from "../../styles/fonts";
import { CSS_COLORS } from "../../styles/styles-css-variables";
import type { TranslatedValue } from "@swo/storefront";
import { T } from "../T";

export const IconWithTextElement: React.FC<
  React.PropsWithChildren<{
    media: AssetType;
    headline: TranslatedValue | undefined;
    subheadline: string | TranslatedValue | undefined | null;
  }>
> = ({ media, headline, subheadline, children }) => {
  return (
    <>
      {headline && (
        <span css={headlineStyles}>
          <T>{headline}</T>
        </span>
      )}

      <img src={media.url} alt={media.description || media.title} loading={"lazy"} />

      {subheadline && (
        <span css={subHeadlineStyles}>
          <T>{subheadline}</T>
        </span>
      )}

      {children}
    </>
  );
};

const headlineStyles = [
  FONTS.MinervaModern500,
  fontSize.x25,
  css`
    color: ${CSS_COLORS.Green};
    text-transform: uppercase;

    margin-bottom: 20px;
  `,
];

const subHeadlineStyles = [
  FONTS.SwarovskiFutura500,
  fontSize.x2,
  css`
    text-transform: uppercase;

    margin-bottom: 16px;
  `,
];
